<template>
  <div class="load" :class="[
    {'gray' : color === 'gray'},
    {'white' : color === 'white'},
    {'black' : color === 'black'}
  ]">
    <div class="dot" v-if="1 <= dots"></div>
    <div class="dot" v-if="2 <= dots"></div>
    <div class="dot" v-if="3 <= dots"></div>
    <div class="dot" v-if="4 <= dots"></div>
    <div class="dot" v-if="5 <= dots"></div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    color: {
      type: String,
      default: 'gray',
    },
    dots: {
      type: Number,
      default: 5,
    },
  },
};
</script>

<style lang="sass">
@keyframes animacao
  0%,100%
    transform: scale(0.2)

  50%
    transform: scale(1)
.load
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%,-50%)

  &.gray
    .dot
      background-color: gray

  &.white
    .dot
      background-color: white

  &.black
    .dot
      background-color: black

  .dot
    width: 15px
    height: 15px
    border-radius: 50%
    margin: 10px
    display: inline-block
    transform: scale(0.2)
    animation: animacao 1.2s infinite

    &:nth-child(2)
      animation-delay: 0.2s
    &:nth-child(3)
      animation-delay: 0.4s
    &:nth-child(4)
      animation-delay: 0.7s
    &:nth-child(5)
      animation-delay: 1s
    &:nth-child(6)
      animation-delay: 1.2s

</style>
